import { render, staticRenderFns } from "./Correduria.vue?vue&type=template&id=c8907042"
import script from "./Correduria.vue?vue&type=script&lang=js"
export * from "./Correduria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8907042')) {
      api.createRecord('c8907042', component.options)
    } else {
      api.reload('c8907042', component.options)
    }
    module.hot.accept("./Correduria.vue?vue&type=template&id=c8907042", function () {
      api.rerender('c8907042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Correduria.vue"
export default component.exports